import React from 'react';
import { Box, SxProps } from '@mui/material';
import {
  useElementProposalsResults,
  useHiddenProposal,
} from '@features/proposals/use-proposals.hooks';
import {
  useGetResultsPerGFA,
  useElementResults,
} from '@features/results/use-results.hooks';
import { getCo2eChartDataFromResults } from '@ui/BarChart/helpers/bar-chart.helpers';
import { SimpleBarChart, ISimpleBarChartValue } from '@ui/BarChart';
import { OneOfElementListElements } from '@shared/models/project.model';
import { IProposal } from '@shared/models/proposals.model';
import { ELEMENT_CO2_BAR_HEIGHT } from '@ui/ElementList';
import { useElementSelectedProposalColor } from '@features/proposals/hooks/use-proposals.hooks';

type IElementProposalBarChartProps = {
  proposal: IProposal | IProposal;
  element: OneOfElementListElements;
  maxValue: number;
};

export const ElementProposalBarChart: React.FC<
  IElementProposalBarChartProps
> = ({ proposal, element, maxValue }) => {
  const getResultsPerGFA = useGetResultsPerGFA();
  const color = useElementSelectedProposalColor(element);

  const elementProposalsResults = useElementProposalsResults(element);
  const elementResults = useElementResults(element);
  const proposalIsHidden = useHiddenProposal(proposal.id);

  const proposalResult = elementProposalsResults[proposal.id];

  const resultsPerGFA = getResultsPerGFA(proposalResult ?? elementResults);

  const co2Values: ISimpleBarChartValue[] =
    getCo2eChartDataFromResults(resultsPerGFA);

  return (
    !proposalIsHidden && (
      <Box key={'wrapper-' + proposal.id} sx={boxSx}>
        <SimpleBarChart
          key={proposal.id}
          value={co2Values}
          maxValue={maxValue}
          height={ELEMENT_CO2_BAR_HEIGHT}
          color={color}
        />
      </Box>
    )
  );
};

const boxSx: SxProps = {
  width: '100%',
  '&:not(:last-child)': {
    marginBottom: '2px',
  },
};
